export default __webpack_public_path__ + "static/media/membre_imad.d31b61b1.jpg";